<template>
  <div class="wt2-check-box-component" :class="{ '-disabled': disabled }">
    <label
      v-if="labelLeft"
      :for="guid"
      :title="labelTooltip"
      v-html="labelLeft"
      class="-label-left"
    ></label>
    <input
      type="checkbox"
      :id="guid"
      :checked="checked"
      :disabled="disabled"
      @change="onChange($event)"
      ref="input"
    />
    <label :for="guid" class="-body">
      <i class="wticon wticon-toggle_v"></i>
    </label>
    <label
      v-if="labelRight"
      :for="guid"
      :title="labelTooltip"
      v-html="labelRight"
      class="-label-right"
    ></label>
  </div>
</template>

<script>
import app from 'app';

export default {
  model: {
    prop: 'checked',
    event: 'changed',
  },

  props: {
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    labelLeft: {
      type: String,
      required: false,
      default: '',
    },
    labelRight: {
      type: String,
      required: false,
      default: '',
    },
    labelTooltip: {
      type: String,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  watch: {
    checked(newVal) {
      this.$refs.input.checked = newVal;
    },

    disabled() {
      this.$refs.input.disabled = this.disabled;
    },
  },

  data() {
    return {
      guid: app.guid(),
    };
  },

  methods: {
    onChange(e) {
      this.$emit('changed', e.target.checked);
    },
  },
};
</script>
